
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import ParamAirlineCompanyAppService from "@/apis.machine/ParamAirlineCompanyAppService";
import DtoDetailParamAirlineCompany, {
  DtoDetailParamAirlineCompanyMiezzDetailItems,
} from "@/models.machine/DtoDetailParamAirlineCompany";
import ParamAirlineCompanyForm from "./ParamAirlineCompanyForm.vue";
import router from "@/router";

@Options({
  components: {
    ParamAirlineCompanyForm,
  },
})
export default class ParamAirlineCompanyDetail extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  detail = new MiezzForm<DtoDetailParamAirlineCompany, string>(
    "System_ParamList_AirlineCompany_Detail"
  );
  modalForm = new MiezzModal();

  /**创建时 */
  created(): void {
    //详细-数据-初始化
    this.detail.Data = new DtoDetailParamAirlineCompany();
    //详细-元素配置
    this.detail.Items = DtoDetailParamAirlineCompanyMiezzDetailItems;

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "edit",
        Title: "编辑",
        Icon: "edit",
        Type: "default",
        Size: "small",
        PowerCode: "System_ParamList_AirlineCompany_AddEdit",
      },
      {
        Code: "delete",
        Title: "删除",
        Icon: "delete",
        Type: "default",
        Message: "是否确认删除",
        Size: "small",
        PowerCode: "System_ParamList_AirlineCompany_Delete",
      },
    ];
    this.handleGet();
  }

  /**查询详细 */
  handleGet(): void {
    if (this.id) {
      ParamAirlineCompanyAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.detail.Data = r.data.Data;
      });
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "edit":
        var query = router.currentRoute.value.query;
        query.Drawer = "edit";
        router.push({
          query: query,
          force: true,
        });
        complete();
        break;
      case "delete":
        ParamAirlineCompanyAppService.Delete([this.id as string])
          .then(() => {
            this.handleDelete();
            complete();
          })
          .catch(complete);
        break;
      default:
        break;
    }
  }

  /**提交表单 */
  @Emit()
  handleSubmit(): void {
    this.modalForm.Show = false;
    this.handleGet();
  }

  /**删除 */
  @Emit()
  handleDelete(): void {
    //
  }
}
